export const initArea = (data) => ({
  type: "INIT_AREA",
  payload: data,
});
